export var AdobeAnalyticsConstants;
(function (AdobeAnalyticsConstants) {
    AdobeAnalyticsConstants["FantDuDetDuLetteEtter"] = "fant du det du lette etter";
    AdobeAnalyticsConstants["Feedback"] = "feedback";
    AdobeAnalyticsConstants["Answer"] = "answer";
})(AdobeAnalyticsConstants || (AdobeAnalyticsConstants = {}));
